//src/lib/config.js
import { AuthenticationContext } from "react-adal";
import { AUTH_CONFIG } from "./auth0Variables";
//console.log("AUTH_CONFIG" + JSON.stringify(AUTH_CONFIG));
export const adalConfig = {
  tenant: AUTH_CONFIG.TENANT,
  popup: false,
  clientId: AUTH_CONFIG.CLIENT_ID,
  endpoints: {
    "https://graph.microsoft.com/v1.0/me": "https://graph.microsoft.com",
  },
  navigateToLoginRequestUrl: false,
  extraQueryParameter: "",
  postLogoutRedirectUri: window.location.origin,
  redirectUri: AUTH_CONFIG.callbackUrl,
  cacheLocation: "sessionStorage",
  expireOffsetSeconds: 300, // Renew 5 minutes before expiry
  loadFrameTimeout: 6000,
};
//console.log(process.env.REACT_APP_AUTH0_CALLBACK);

export const authContext = new AuthenticationContext(adalConfig);
